export default __webpack_public_path__ + "static/media/ReportHeadingArrow.ef6c885f.svg";